var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 13.2939C17 13.9847 16.44 14.5439 15.75 14.5439H8.25C7.56 14.5439 7 13.9847 7 13.2939C7 12.603 7.56 12.0439 8.25 12.0439H15.75C16.44 12.0439 17 12.603 17 13.2939ZM11.5833 16.2105H8.25C7.56 16.2105 7 16.7697 7 17.4605C7 18.1514 7.56 18.7105 8.25 18.7105H11.5833C12.2733 18.7105 12.8333 18.1514 12.8333 17.4605C12.8333 16.7697 12.2733 16.2105 11.5833 16.2105ZM22 9.1272V18.2939C22 20.8214 19.9433 22.8772 17.4167 22.8772H6.58333C4.05667 22.8772 2 20.8214 2 18.2939V9.1272C2 6.5997 4.05667 4.54386 6.58333 4.54386H7V4.1272C7 3.43636 7.56 2.8772 8.25 2.8772C8.94 2.8772 9.5 3.43636 9.5 4.1272V4.54386H14.5V4.1272C14.5 3.43636 15.06 2.8772 15.75 2.8772C16.44 2.8772 17 3.43636 17 4.1272V4.54386H17.4167C19.9433 4.54386 22 6.5997 22 9.1272ZM19.5 18.2939V10.3772H4.5V18.2939C4.5 19.4422 5.43417 20.3772 6.58333 20.3772H17.4167C18.5658 20.3772 19.5 19.4422 19.5 18.2939Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarwhite);
export default __webpack_public_path__ + "static/media/Calendar white.864da3108d5d38fdb04ec28cd855e438.svg";
export { ForwardRef as ReactComponent };